import Home from '../views/Home.vue';
import Notifications from '../views/Notifications.vue';
import Reunions from '../views/Reunions.vue';
import Inspirations from '../views/Inspirations.vue';
import Kanban from '../views/Kanban.vue';
import Brief from '../views/Brief.vue';
import DesignToLight from '../views/DesignToLight.vue';
import Login from '../views/Login.vue';
import Account from '../views/Account.vue';

const routes = [
  {
    path: '/:locale?',
    component: Home,
  },
  {
    name: 'Login',
    path: '/:locale?/login',
    component: Login,
  },
  {
    name: 'Account',
    path: '/:locale?/account',
    component: Account,
  },
  {
    path: '/:locale?/notifications',
    component: Notifications,
  },
  {
    path: '/:locale?/reunions',
    component: Reunions,
  },
  {
    path: '/:locale?/inspirations',
    component: Inspirations,
  },
  {
    path: '/:locale?/design-to-light',
    component: DesignToLight,
  },
  {
    path: '/:locale?/projects/:id',
    component: Kanban,
  },
  {
    path: '/:locale?/projects/:id/client-brief',
    component: Brief,
  },
  {
    path: '/:locale?/projects/:id/extended-brief',
    component: Brief,
  },

  // Redirections
  {
    path: '/:locale?/projects/:id/industrial-ideation',
    redirect: (to) => {
      const prefix = to.params.locale === 'en' ? '/en' : '';
      return (
        prefix +
        '/projects/' +
        to.params.id +
        '?dialog=industrial-ideation&comments=true'
      );
    },
  },
  {
    path: '/:locale?/projects/:id/proposal',
    redirect: (to) => {
      const prefix = to.params.locale === 'en' ? '/en' : '';
      return prefix + '/projects/' + to.params.id + '?dialog=proposal&comments=true';
    },
  },
];

export default routes;
